<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99967 1.33203C4.31967 1.33203 1.33301 4.3187 1.33301 7.9987C1.33301 11.6787 4.31967 14.6654 7.99967 14.6654C11.6797 14.6654 14.6663 11.6787 14.6663 7.9987C14.6663 4.3187 11.6797 1.33203 7.99967 1.33203ZM8.66634 12.6654H7.33301V11.332H8.66634V12.6654ZM10.0463 7.4987L9.44634 8.11203C8.96634 8.5987 8.66634 8.9987 8.66634 9.9987H7.33301V9.66537C7.33301 8.93203 7.63301 8.26536 8.11301 7.7787L8.93967 6.9387C9.18634 6.6987 9.33301 6.36536 9.33301 5.9987C9.33301 5.26536 8.73301 4.66536 7.99967 4.66536C7.26634 4.66536 6.66634 5.26536 6.66634 5.9987H5.33301C5.33301 4.52536 6.52634 3.33203 7.99967 3.33203C9.47301 3.33203 10.6663 4.52536 10.6663 5.9987C10.6663 6.58536 10.4263 7.1187 10.0463 7.4987Z"
      fill="#8897AA"
    />
  </svg>
</template>

<script>
export default {}
</script>

<style>
</style>
